const getDecimalSeparator = (locale: Intl.LocalesArgument) => {
  const numberWithDecimalSeparator = 1.1;
  return numberWithDecimalSeparator.toLocaleString(locale).substring(1, 2);
};

export default getDecimalSeparator;
